import { NonIdealState } from '@blueprintjs/core'
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useTranslation } from 'react-i18next'

function MobileMain () {
  const { t } = useTranslation()
  return (
    <NonIdealState icon={'ban-circle'} title={t('The mobile version is not ready yet')} css={css`position: absolute; width: 100%; height: 100%;`} />
  )
}

export default MobileMain
